import { useEffect } from "react"
import { useTheme } from "next-themes"

import { useAuth } from "@/lib/auth"
import { supabase } from "@/lib/supabase"
import type { AppTheme } from "@/types/user-settings"

/**
 * Syncs `profiles.theme` to next-themes after sign-in. Keeps dashboard language-style sync separate from the settings hook.
 */
export function ProfileThemeSync() {
  const { user } = useAuth()
  const { setTheme } = useTheme()

  useEffect(() => {
    if (!user?.id) return
    let cancelled = false
    void (async () => {
      const { data, error } = await supabase
        .from("profiles")
        .select("theme")
        .eq("id", user.id)
        .maybeSingle()
      if (error || cancelled) return
      const t = (data?.theme as AppTheme) || "system"
      if (t === "light" || t === "dark" || t === "system") {
        setTheme(t)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [user?.id, setTheme])

  return null
}
